module.exports = __webpack_public_path__ + "static/media/v_logo_vip-cerave.46bcb843.png";